import { useDispatch, useSelector } from 'react-redux';
import { MenuProps, Tabs } from 'antd';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';

import { redirectToUrl } from 'common/actions/navigationAction';
import { isAdmin as getIsAdmin } from 'features/user/selectors/userSelectors';
import { isContractManager as getIsContractManager } from 'features/contract/selectors/contractSelectors';
import { ContentMenuLink, MenuLinks } from 'common/models/navigationModel';
import { breakpoints, colors } from 'theme/variables';

const ContentMenuWrapper = styled.div<{ small?: boolean }>(
    ({ small }) => `
    border-radius: 4px 4px 0 0;
    width: 100%;
    background-color: ${small ? colors.lightGray : colors.primaryWhite};

    .ant-tabs {

        > .ant-tabs-nav {
            margin-bottom: 0;
            height: ${small ? '32px' : 'auto'};

            .ant-tabs-nav-wrap {
                justify-content: flex-start;
                padding-left: 32px;

                ${breakpoints.desktop} {
                    justify-content: center;
                }

                .ant-tabs-nav-list {
                    padding-right: 32px;
                }

                .ant-tabs-tab {
                    font-size: ${small ? '12px' : '14px'};
                }
            }
        }
    }
`,
);

type Props = MenuProps &
    MenuLinks & {
        small?: boolean;
    };

export const ContentMenu = ({
    adminMenuLinks,
    contractManagerMenuLinks,
    menuLinks,
    small,
}: Props) => {
    const dispatch = useDispatch();
    const { pathname } = useLocation();

    const isContractManager = useSelector(getIsContractManager);
    const isAdmin = useSelector(getIsAdmin);

    const handleOnChange = (key: string) => {
        dispatch(redirectToUrl(key));
    };

    let links: ContentMenuLink[] | undefined;

    if (isAdmin && adminMenuLinks) {
        links = adminMenuLinks;
    } else if (isContractManager && contractManagerMenuLinks) {
        links = contractManagerMenuLinks;
    } else if (menuLinks) {
        links = menuLinks;
    }

    if (!links) {
        return null;
    }

    return (
        <ContentMenuWrapper small={small}>
            <Tabs
                onChange={handleOnChange}
                defaultActiveKey={
                    links.find(
                        (link) =>
                            pathname === link.key ||
                            link.additionalActiveKeys?.find((key) => pathname === key),
                    )?.key
                }
                animated={false}
            >
                {links.map(({ key, label, Icon }) => (
                    <Tabs.TabPane
                        key={key}
                        tab={
                            Icon ? (
                                <>
                                    {Icon}
                                    {label}
                                </>
                            ) : (
                                label
                            )
                        }
                    />
                ))}
            </Tabs>
        </ContentMenuWrapper>
    );
};
